import { render, staticRenderFns } from "./MatchTask.vue?vue&type=template&id=711bfc55&scoped=true"
import script from "./MatchTask.vue?vue&type=script&lang=js"
export * from "./MatchTask.vue?vue&type=script&lang=js"
import style0 from "./MatchTask.vue?vue&type=style&index=0&id=711bfc55&prod&scoped=true&lang=stylus"
import style1 from "./MatchTask.vue?vue&type=style&index=1&id=711bfc55&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711bfc55",
  null
  
)

export default component.exports